import { render, staticRenderFns } from "./VendorInfoElement.vue?vue&type=template&id=50b2de10&scoped=true&"
import script from "./VendorInfoElement.vue?vue&type=script&lang=js&"
export * from "./VendorInfoElement.vue?vue&type=script&lang=js&"
import style0 from "./VendorInfoElement.vue?vue&type=style&index=0&id=50b2de10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b2de10",
  null
  
)

export default component.exports